const productSwiper = new Swiper('.product_list_box_wrap', {
  slidesPerView: 1,
  spaceBetween: 20,

  breakpoints: {
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 3
    }
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});

const hairmilkSwiper = new Swiper('.sp_swiper', {
  slidesPerView: 1,

  breakpoints: {
    960: {
      enabled: false
    }
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  }
});
